import { useEffect, useState } from "react"
import './pageController.css'

const PageController = ({ initData, setInitData, length }) => {

    const pagesize = parseInt(process.env.REACT_APP_PAGE_RECORDS);
    const numDatos = parseInt(length)
    const [btnFirst, setBtnFirst] = useState(false)
    const [btnLast, setBtnLast] = useState(false)
    const [btnPrev, setBtnPrev] = useState(false)
    const [btnNext, setBtnNext] = useState(false)
    const [actualPage, setActualPage] = useState(1);
    const [totalPage, setTotalPage] = useState(Math.ceil(numDatos / pagesize));

    useEffect(() => {
        setTotalPage(Math.ceil(numDatos / pagesize))       
    }, [length, pagesize, numDatos]);


    useEffect(() => {
        const loadData = async () => {
            await setInitData((actualPage - 1) * pagesize)
            if(totalPage>1 && actualPage!==totalPage) {
                setBtnNext(true)
                setBtnLast(true)
            }
        }
        loadData()
    }, [actualPage,totalPage, setInitData, pagesize])

    const firstRecords = () => {
        setActualPage(1)
        blockButtons(false)
    }
    const lastRecords = () => {
        setActualPage(totalPage)
        blockButtons(true)
    }

    const prevRecords = () => {
        setActualPage(actualPage - 1)
        setBtnFirst(true)
        setBtnPrev(true)
        setBtnNext(true)
        setBtnLast(true)
        if (actualPage-1 === 1) blockButtons(false)
    }
    const nextRecords = () => {
        setActualPage(actualPage + 1)
        setBtnFirst(true)
        setBtnPrev(true)
        setBtnNext(true)
        setBtnLast(true)
        if (actualPage+1 === totalPage) blockButtons(true)
    }

    const blockButtons = (end)=>{
        setBtnFirst(end)
        setBtnPrev(end)
        setBtnNext(!end)
        setBtnLast(!end)
    }


    return (
        <>

            <div className="pagination">

                <button className="material-icons-outlined btn-res"
                    onClick={firstRecords} disabled={!btnFirst}>first_page</button>

                <button className="material-icons-outlined"
                    onClick={prevRecords} disabled={!btnPrev}>arrow_back_ios</button>

                <label className="contador">Página {actualPage} de {totalPage}</label>

                <button className="material-icons-outlined"
                    onClick={nextRecords} disabled={!btnNext}>arrow_forward_ios</button>

                <button className="material-icons-outlined btn-res"
                    onClick={lastRecords} disabled={!btnLast}>last_page</button>
            </div>
            <p className="itemCount">{numDatos} registros</p>
        </>
    )
}
export default PageController